export const DataDropCard = ({ data }) => {
  const topCols = (data.columns || []).slice(0, 6);
  const gradeColor = data.grade === "A" || data.grade === "B" ? "#4ADE80" : data.grade === "C" ? "#F59E0B" : "#FF5C5C";
  return (
    <div className="relative overflow-hidden rounded-2xl border border-[#2E2E2E] bg-[#111111] p-6 md:p-8 max-w-2xl space-y-4" data-testid="datadrop-card">
      <div className="absolute top-0 left-0 w-full h-1 bg-[#DC2626]" />
      <p className="text-base font-bold text-[#FF5C5C] pt-1">Your file at a glance</p>
      {data.grade && (
        <div className="flex items-center gap-5 rounded-xl border border-[#2E2E2E] bg-[#050505] p-5" data-testid="datadrop-grade-block">
          <div
            className="shrink-0 w-16 h-16 rounded-xl flex items-center justify-center font-display text-4xl"
            style={{ border: `2px solid ${gradeColor}`, color: gradeColor }}
            data-testid="datadrop-grade"
          >
            {data.grade}
          </div>
          <div className="min-w-0">
            <p className="text-base font-bold text-white leading-snug" data-testid="datadrop-grade-verdict">{data.grade_verdict}</p>
            <ul className="mt-1.5 space-y-1">
              {(data.grade_notes || []).map((n) => (
                <li key={n} className="text-base font-medium text-[#D6D6D6] leading-[1.5]" data-testid="datadrop-grade-note">{n}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-x-10 gap-y-3">
        <div>
          <p className="font-display text-3xl text-white" data-testid="datadrop-rows">{data.rows.toLocaleString()}</p>
          <p className="text-base font-medium text-[#D6D6D6]">Rows</p>
        </div>
        <div>
          <p className="font-display text-3xl text-white">{data.column_count}</p>
          <p className="text-base font-medium text-[#D6D6D6]">Columns</p>
        </div>
        <div>
          <p className="font-display text-3xl text-[#4ADE80]" data-testid="datadrop-turnaround">{data.turnaround}</p>
          <p className="text-base font-medium text-[#D6D6D6]">Turnaround</p>
        </div>
      </div>
      <div className="space-y-2">
        {topCols.map((c) => (
          <div key={c.name} className="flex items-center gap-3">
            <span className="text-base font-medium text-[#D6D6D6] w-36 truncate">{c.name}</span>
            <div className="flex-1 h-1.5 rounded-full bg-[#2E2E2E]">
              <div className="h-full rounded-full bg-[#DC2626]" style={{ width: `${c.fill_pct}%` }} />
            </div>
            <span className="text-base font-medium text-[#D6D6D6] w-14 text-right">{c.fill_pct}%</span>
          </div>
        ))}
        {data.column_count > 6 && <p className="text-base font-medium text-[#D6D6D6]">+ {data.column_count - 6} more columns</p>}
      </div>
      <div className="flex flex-wrap gap-2">
        {(data.recommended || []).map((r) => (
          <span key={r} className="text-base font-semibold rounded-full border border-[#FF5C5C] text-[#FF5C5C] px-3 py-1">{r}</span>
        ))}
      </div>
      <p className="text-base font-medium text-[#D6D6D6] leading-[1.6]">These numbers hold for files like this. If you'd like it done, say "book a call" and I'll open the calendar.</p>
    </div>
  );
};
